module.exports = __webpack_public_path__ + "img/placeholder.300f83d7.svg";